//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { SchemaDescription, SchemaFieldDescription } from 'yup'
import * as React from 'react'
import { ReactElement } from 'react'
import { Switch, Typography } from '@mui/material'
import { FieldMetaData } from '@shared/SchemaTypes'
import { EthAddr } from '@shared/SchemaTypes'
import getDataValue from './getDataValue'

import { logOT } from '@shared/loggingShared'

interface EditFieldProps {
  fieldSchema: SchemaFieldDescription
  initialValues?: Record<string, object> | object
  onChange?: (e: Event) => void
  register: any
  errors: any
  setValue: any
  addr?: EthAddr
}

export default function EditBoolean(props: EditFieldProps): ReactElement {
  const { fieldSchema, initialValues, errors, register, setValue } = props

  const schemaDescription = fieldSchema as SchemaDescription
  const fieldMetaData = schemaDescription.meta as FieldMetaData

  const propName: string = fieldMetaData.propName
  const defaultValue = getDataValue(initialValues as Record<string, object | string>, propName)
  logOT.debug('defaultValue', defaultValue, initialValues, propName)
  const [boolValue, setBoolValue] = React.useState<boolean>(defaultValue)
  logOT.debug('Default Value ', propName, defaultValue)
  const { name, ref } = register(propName)

  const label = schemaDescription.label ?? ''

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    logOT.info('EditBoolean handleOnChange', event)
    logOT.info('EditBoolean handleOnChange', event.target.checked)
    setBoolValue(event.target.checked)

    logOT.info('EditBoolean setValue', propName, event.target.checked)
    setValue(propName, event.target.checked)
  }

  return (
    <React.Fragment>
      <Typography variant="bodyMuted" gutterBottom component="div">
        {label}
      </Typography>
      <Switch id={propName} value={boolValue} onChange={handleOnChange} name={name} ref={ref} />
      <Typography variant="inherit" color="textSecondary">
        {errors[propName]?.message}
      </Typography>
    </React.Fragment>
  )
}
